
export default class MarketersController {

	constructor (marketers, $state, Marketer, $filter) {
		var translate = $filter('translate');
		var buttons = [
			{ label: translate('EDIT'),   action: this.edit.bind(this) },
			{ label: translate('REMOVE'), action: this.remove.bind(this) },
		];
		this.headers = [
			{ key: 'id',         label: '#',                  type: 'text' },
			{ key: 'name',       label: translate('NAME'),    type: 'text' },
			{ key: 'email',      label: translate('EMAIL'),   type: 'text' },
			{ key: 'zone',       label: translate('ZONE'),    type: 'text' },
			// { key: 'canWrite',   label: translate('WRITE'),   type: 'check' },
			// { key: 'canPublish', label: translate('PUBLISH'), type: 'check' },
			{ key: 'super',      label: translate('SUPER'),   type: 'check' },
			{ key: '',           label: '',                   type: 'buttons', buttons },
		];
		this.marketers = marketers;
		this.Marketer = Marketer;
		this.$state = $state;
		this.translate = translate;
	}

	create () {
		this.$state.go('marketerCreatePage');
	}

	edit (marketer) {
		this.$state.go('marketerEditPage', marketer);
	}

	reload () {
		this.$state.go('marketersPage', {}, { reload: true });
	}

	remove (marketer) {
		swal({
			title: this.translate('ARE_YOU_SURE'),
			text: `${this.translate('QUESTION_DELETE_MARKETER')} "${marketer.name}"`,
			type: 'warning',
			showCancelButton: true
		}, confirm => confirm && this.Marketer.delete(marketer.id).then(this.reload.bind(this)));
	}

}

MarketersController.$inject = ['marketers', '$state', 'Marketer', '$filter'];



// WEBPACK FOOTER //
// ./src/page/marketers/marketers.controller.js